import {Profile} from "../../domain/profile.entity";
import {UpdateProfileParams, AvailabilityResult} from "../../domain/profile.types";
import {httpClientV2} from "../../../../infrastructure/http";
import {ProfileMapperV2} from "../mappers/profile.mapper.v2";
import {
  V2ProfileResponse,
  V2UpdateProfileResponse,
} from "../mappers/profile.mapper.types";
import {ProfileRepository} from "./profile.repository";

/**
 * V2 API implementation of ProfileRepository.
 *
 * Pure TypeScript - no React imports.
 */
export class ProfileRepositoryV2 implements ProfileRepository {
  async getProfile(): Promise<Profile> {
    const response = await httpClientV2.get<{data: V2ProfileResponse}>("profile");
    return ProfileMapperV2.toDomain(response.data);
  }

  async updateProfile(params: UpdateProfileParams): Promise<Profile> {
    const request = ProfileMapperV2.toUpdateRequest(params);
    // First get current profile so we can merge with the flat update response
    const currentProfile = await this.getProfile();
    const response = await httpClientV2.post<{data: V2UpdateProfileResponse}>(
      "profile",
      request
    );
    return ProfileMapperV2.toDomainFromUpdate(response.data, currentProfile);
  }

  async verifyDisplayName(displayName: string): Promise<AvailabilityResult> {
    const response = await httpClientV2.get<{data: {isAvailable?: boolean}}>(
      `profile/display-name/validate/${encodeURIComponent(displayName)}`
    );
    return {isAvailable: response.data.isAvailable ?? false};
  }

  async verifyUsername(username: string): Promise<AvailabilityResult> {
    const response = await httpClientV2.get<{data: {isAvailable?: boolean}}>(
      `profile/username/validate/${encodeURIComponent(username)}`
    );
    return {isAvailable: response.data.isAvailable ?? false};
  }

  async checkDisplayNameStatus(): Promise<AvailabilityResult> {
    const response = await httpClientV2.get<{data: {isAvailable?: boolean}}>(
      "profile/display-name/status"
    );
    return {isAvailable: response.data.isAvailable ?? false};
  }
}
